var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top"},[_c('body',{staticStyle:{"margin-top":"0%","background-color":"#000"},attrs:{"id":"particles-js"}}),_c('div',{staticClass:"home-btn d-none d-sm-block pt-0"}),_c('div',{staticClass:"account-pages my-0 pt-0"},[_c('div',{staticClass:"container pt-5"},[_c('h1',{staticClass:"text-success"}),_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }